export default Object.freeze({
	PROPORCIONAL: 'proporcional',
	INTEGRAL: 'integral'
});
